var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-top-btn-style"},[_vm._m(0),_c('div',{staticClass:"switchbtn",on:{"click":_vm.switchbtnfun}},[_c('span',[_vm._v("民意调查")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switchbtn selectswitbtn"},[_c('span',[_vm._v("\"石榴籽\"调解")])])
}]

export { render, staticRenderFns }